import { render } from "./DashboardCustomizeDrawer.vue?vue&type=template&id=10ef85d7"
import script from "./DashboardCustomizeDrawer.vue?vue&type=script&lang=js"
export * from "./DashboardCustomizeDrawer.vue?vue&type=script&lang=js"

import "./DashboardCustomizeDrawer.vue?vue&type=style&index=0&id=10ef85d7&lang=css"

import exportComponent from "/var/www/service/service-cp-company/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__